module.exports = __webpack_public_path__ + "d50a6d467cf5861e9c67a3bb8f1bfb36.png";